import { render, staticRenderFns } from "./TrAudio.vue?vue&type=template&id=6ab0a470&"
import script from "./TrAudio.vue?vue&type=script&lang=js&"
export * from "./TrAudio.vue?vue&type=script&lang=js&"
import style0 from "./TrAudio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports